// Vectors and icons by <a href="https://www.svgrepo.com" target="_blank">SVG Repo</a>

import React, { Component } from 'react';
import { Chart as ChartJS, registerables } from 'chart.js';
import { Chart } from 'react-chartjs-2'
import getChartTextPlugin,{getChartSVGPlugin} from "../../tools/chartFunctions";
import './Histogram.css';
import annotationPlugin from 'chartjs-plugin-annotation';
import Strings from 'localization/Strings';

class Histogram extends Component {
  iconSize = {x:30, y:30};
  // CircleUserSVGString = `<svg  fill="#4e5161" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"><!--! Font Awesome Free 6.3.0 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license/free (Icons: CC BY 4.0, Fonts: SIL OFL 1.1, Code: MIT License) Copyright 2023 Fonticons, Inc. --><path d="M399 384.2C376.9 345.8 335.4 320 288 320H224c-47.4 0-88.9 25.8-111 64.2c35.2 39.2 86.2 63.8 143 63.8s107.8-24.7 143-63.8zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm256 16a72 72 0 1 0 0-144 72 72 0 1 0 0 144z"/></svg>`;
  // used this tool to generate: https://www.svgrepo.com/svg/176186/up-right-arrow?edit=true
  // licence: no copyright (cc0)
  // ArrowSVGString = `<svg fill="#3bbb58" version="1.1" id="Capa_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="180px" height="180px" viewBox="-38.7 -38.7 1044.90 1044.90" xml:space="preserve" stroke="#3bbb58" stroke-width="0.009675" transform="rotate(0)"><g id="SVGRepo_bgCarrier" stroke-width="0"></g><g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round" stroke="#e3e3e3" stroke-width="34.83"> <g> <path d="M120.1,967.5c-30.7,0-61.4-11.699-84.9-35.1c-46.8-46.9-46.8-122.9,0-169.801L557.801,240H327.1c-66.3,0-120-53.7-120-120 c0-66.3,53.7-120,120-120h520.401c0.1,0,0.2,0,0.2,0c19.8,0,39.5,5,56.899,14.4c0,0,0.101,0,0.101,0.1 c21.6,11.8,39.199,30.1,50.199,52.1c8.301,16.5,12.5,35,12.5,53.4v520.4c0,66.299-53.699,120-120,120c-66.3,0-120-53.701-120-120 V409.7L204.9,932.301C181.5,955.801,150.8,967.5,120.1,967.5z"></path> </g> </g><g id="SVGRepo_iconCarrier"> <g> <path d="M120.1,967.5c-30.7,0-61.4-11.699-84.9-35.1c-46.8-46.9-46.8-122.9,0-169.801L557.801,240H327.1c-66.3,0-120-53.7-120-120 c0-66.3,53.7-120,120-120h520.401c0.1,0,0.2,0,0.2,0c19.8,0,39.5,5,56.899,14.4c0,0,0.101,0,0.101,0.1 c21.6,11.8,39.199,30.1,50.199,52.1c8.301,16.5,12.5,35,12.5,53.4v520.4c0,66.299-53.699,120-120,120c-66.3,0-120-53.701-120-120 V409.7L204.9,932.301C181.5,955.801,150.8,967.5,120.1,967.5z"></path> </g> </g></svg>`;
  
  chartSVGPlugin = [];
    constructor(props){ 
        super(props);
        ChartJS.register(...registerables);
        ChartJS.register(annotationPlugin);

        this.topContainer = React.createRef();
        this.currentTitle = React.createRef();
        this.pickTitle = React.createRef();

        this.annotationConfig = this.props?.annotationConfig;
        if (this.annotationConfig == null) {
          const DefaultL = 40; // default config for wordscore with 40 bins
          let L = this.props.labels.length;
          let r = L / DefaultL;
          this.annotationConfig = { // default config for wordscore with 40 bins. if it has less, x-configs is updated with the corresponding ratio.
            offsetY: 0.2,
            boxHeightHalf: 0.1,
            afterOffsetY: 0.15,
            afterBoxHeightHalf: 0.09,
            offsetX: 1 * r,
            boxWidthHalf: 3 * r,
            afterBoxWidthHalf: 2.5 * r,
            afterEnabled: true,
          };
        }
        this.currentUser = this.props?.current;
        this.displayingCurrentUser = this.currentUser;
        if (this.currentUser != null) {
          let err = this.props.labels.map((e) => (Math.abs(e-this.currentUser,2)));
          this.displayingCurrentUserIndex = err.indexOf(Math.min(...err));
          this.displayingCurrentUserX = this.props.labels[this.displayingCurrentUserIndex];
          this.displayingCurrentUserY = this.props.data[this.displayingCurrentUserIndex];

          this.xTicks = this.props.xTicks;
          this.xTickLabels = this.props.xTickLabels;
          this.xRange = this.props.xRange;
          this.yRange = this.props.yRange;
        }

        for (let i = 0; i < this.xTicks?.length; i++){

          this.chartSVGPlugin.push(getChartTextPlugin('currentTitle', 
                                                        this.xTickLabels[i], 
                                                        this.xTicks[i], 
                                                        0, 
                                                        'dataValue', 
                                                        'dataValue', 
                                                        null, 
                                                        20)); 
        }
      }
    render () {
      let afterString = Strings.strings.Results.After;
      let youString = Strings.strings.Results.You;
      let ind = this.displayingCurrentUserIndex;
      let y =  this.displayingCurrentUserY;
      let afterMaxInd = this.props.data.indexOf(Math.max(...this.props.data));
      let afterMaxY = this.props.data[afterMaxInd];
      let afterEnabled = this.annotationConfig.afterEnabled && ind != afterMaxInd;
      let cornerBias = 0;
      if (ind === 0) {
        cornerBias = 0.5;
      }
      else if (ind === this.props.labels.length-1) {
        cornerBias = -0.5;
      }

      return (
            <div className='' style={{"height":"285px"}} >
                <Chart type='bar'  
                  id = "barChart"
                  plugins={ this.chartSVGPlugin}
                  data={{
                      labels: this.props.labels,
                      datasets: [{
                          barPercentage: 1.0,
                          barThickness: 'flex',
                          minBarLength: 2,
                          data: this.props.data,
                          borderRadius: 5,
                          borderWidth:0,
                        backgroundColor: "#584DAE",
                      }]                        
                  }}
                  options={{ 
                    responsive:true,
                    maintainAspectRatio: false,                      
                    scales: {
                      x: {
                          border: {
                            display: false
                          },
                          grid: {
                            display: false,
                            drawBorder: false
                          },
                          ticks: {
                            display: false,
                          },
                          min: this.xRange ? this.xRange[0] : null,
                          max: this.xRange ? this.xRange[1] : null,
                        }, 
                        y: {
                          border: {
                            display: false
                          },
                          grid: {
                            display: false,
                            drawBorder: false
                          },
                          ticks: {
                            display: false,
                          },
                          min:  this.yRange ? this.yRange[0] : -0.2,
                          max: this.yRange ? this.yRange[1] : 1 + this.annotationConfig.afterOffsetY*2 + this.annotationConfig.boxHeightHalf,
                        },
                    },
                    title: {
                        display: false,
                    },
                    plugins: {
                      annotation: {
                        annotations: {  
                          boxAfter: {
                            type: 'box',
                            xMin: afterMaxInd-this.annotationConfig.afterBoxWidthHalf, // X-coordinate range
                            xMax: afterMaxInd+this.annotationConfig.afterBoxWidthHalf, // X-coordinate range
                            yMin: afterMaxY + this.annotationConfig.afterOffsetY - this.annotationConfig.afterBoxHeightHalf, // X-coordinate range
                            yMax: afterMaxY + this.annotationConfig.afterOffsetY + this.annotationConfig.afterBoxHeightHalf, // X-coordinate range
                            borderWidth: 0,
                            borderRadius: 100,
                            backgroundColor: afterEnabled ? '#584DAE' : 'rgba(0,0,0,0)'
                          },                          
                          labelAfter: {
                            type: 'label',
                            xValue: afterMaxInd, // X-coordinate range
                            yValue: afterMaxY + this.annotationConfig.afterOffsetY, // Y-coordinate range
                            content: [afterString],
                            color:  afterEnabled ? 'white' : 'rgba(0,0,0,0)',
                            //make invisible
                            font: {
                              family: 'Roboto',
                              size: "16px",
                              weight: '500',
                            }
                          },
                          line1: {
                            type: 'line',
                            yMin: y,
                            yMax: y+this.annotationConfig.offsetY,
                            xMin: ind,
                            xMax: ind,
                            borderColor: '#009F4F',
                            borderWidth: 1,
                          },                          
                          point1: {
                            type: 'point',
                            xValue: ind,
                            yValue: y,
                            radius: 5,
                            borderColor: "#009F4F",
                            borderWidth: 2,
                            backgroundColor: '#CBE8CA'
                          },
                          labelYou: {
                            type: 'box',
                            xMin: ind-this.annotationConfig.boxWidthHalf+cornerBias, // X-coordinate range
                            xMax: ind+this.annotationConfig.boxWidthHalf+cornerBias, // X-coordinate range
                            yMin: y + this.annotationConfig.offsetY - this.annotationConfig.boxHeightHalf, // X-coordinate range
                            yMax: y + this.annotationConfig.offsetY + this.annotationConfig.boxHeightHalf, // X-coordinate range
                            borderWidth: 0,
                            borderRadius: 100,
                            backgroundColor: '#CBE8CA',
                          },
                          icon: {
                            type: 'label',
                            xValue: ind-this.annotationConfig.offsetX * 1.5+cornerBias, // X-coordinate range
                            yValue: y + this.annotationConfig.offsetY, // Y-coordinate range
                            content: [" \uf007 "],
                            color: "#009F4F",
                            backgroundColor: "#ffffff",
                            borderWidth: 2,
                            borderRadius: 100,
                            borderColor: "#009F4F",
                            padding: -1,
                            font: {
                              family: 'fontawesome',
                              size: "15px",
                              weight: '600',
                            }
                          },  
                          label1: {
                            type: 'label',
                            xValue: ind+this.annotationConfig.offsetX+cornerBias, // X-coordinate range
                            yValue: y + this.annotationConfig.offsetY, // Y-coordinate range
                            content: [youString],
                            color: "#009F4F",
                            font: {
                              family: 'Roboto',
                              size: "12rem",
                              weight: '600',
                            }
                          },                                                    
                        }
                      },                                            
                      legend: {
                          display: false,
                      },
                      tooltip: {
                          enabled: false,
                      },
                      datalabels: {
                        display: function(context) {
                          var dataset = context.dataset;
                          var count = dataset.data.length;
                          var value = dataset.data[context.dataIndex];
                          return value > count * 1.5;
                        },                        
                      },
                    }
                  }}
                />
            </div>
        )
      } 
}

export default Histogram;